module.exports = __webpack_public_path__ + "static/media/PPWriter-RegularItalic.35daa61c.otf";